import * as cn from 'classnames'
import * as styles from 'styles/pages/Styleguide.css'
import { Caption } from 'components/atoms/Text'
import HomePriceBalloon from 'components/atoms/balloons/HomePriceBalloon'

const SGBalloons = () => (
  <section className={ cn(styles.sgSection, styles.sgBalloons) }>
    <ul>
      <li>
        <div className={ styles.balloonWrapper }>
          <HomePriceBalloon addressValue='211 W 56th St' price={{ low: 143000, high: 230000, link: 'google.com' }} />
        </div>
        <Caption text='Home Price Balloon' />
      </li>
    </ul>
  </section>
)

export default SGBalloons
